export default __webpack_public_path__ + "static/media/btn_menu.252db37f.svg";